"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_query_1 = require("react-query");
var material_1 = require("@mui/material");
var Pagination_1 = __importDefault(require("@/frontend/react/components/Pagination"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var ContentContext_1 = __importDefault(require("@/frontend/react/context/ContentContext"));
var react_router_dom_1 = require("react-router-dom");
var useIsSmallScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsSmallScreen"));
var ChatTile_1 = __importDefault(require("./ChatTile"));
var Tile_1 = __importDefault(require("../../components/Tile"));
function ChatsList() {
    var _a;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var regex = new RegExp('(chats)/[0-9]');
    var isPath = pathname.match(regex);
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var _b = (0, react_1.useState)(1), page = _b[0], setPage = _b[1];
    var contentConnections = (0, react_1.useContext)(ContentContext_1.default).connections;
    var _c = (0, react_query_1.useQuery)(['chats', "page:".concat(page)], function () {
        return axios_1.default.get("/data/chats?page=".concat(page)).then(function (result) { return result.data; });
    }), isLoading = _c.isLoading, connections = _c.data;
    (0, react_1.useEffect)(function () {
        var _a;
        if (isSmallScreen === false && isLoading === false && !isPath && ((_a = connections === null || connections === void 0 ? void 0 : connections.data) === null || _a === void 0 ? void 0 : _a.length)) {
            navigate("/connections/chats/".concat(connections.data[0].conversationId));
        }
    }, [isLoading, connections, isSmallScreen, isPath]);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(material_1.LinearProgress, {});
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ spacing: 5 }, { children: [((connections === null || connections === void 0 ? void 0 : connections.data) || []).map(function (connection) { return ((0, jsx_runtime_1.jsx)(ChatTile_1.default, { connection: connection }, connection.id)); }), ((_a = connections === null || connections === void 0 ? void 0 : connections.data) === null || _a === void 0 ? void 0 : _a.length) === 0 && (0, jsx_runtime_1.jsx)(Tile_1.default, { children: (0, html_react_parser_1.default)(contentConnections.noConnections) }), (0, jsx_runtime_1.jsx)(Pagination_1.default, { entity: connections, onPageChange: setPage })] })));
}
exports.default = ChatsList;
